<template>
    <div>
        
        <ul class="nav nav-tabs mr-5 leftCustom-width in-trading">
            <li class="nav-item">
                <a class="nav-link active" href="#home" data-toggle="tab">
            {{$t('cal_leftmenu_commision')}} </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#about-one" data-toggle="tab">
            {{$t('cal_leftmenu_margin')}} </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#about-two" data-toggle="tab">
            {{$t('cal_leftmenu_multiTarget')}} </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#about-three" data-toggle="tab">
            {{$t('cal_leftmenu_pivotpoints')}} </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#about-four" data-toggle="tab">
            {{$t('cal_leftmenu_profitloss')}} </a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link" href="#about-five" data-toggle="tab">
            Risk & Rewards</a>
            </li> -->
            <li class="nav-item">
                <a class="nav-link" href="#about-six" data-toggle="tab">
            {{$t('cal_leftmenu_fibonacci')}} </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#about-seven" data-toggle="tab">
            {{$t('cal_leftmenu_pipValue')}} </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#about-eight" data-toggle="tab">
            {{$t('cal_leftmenu_Swap')}} </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#about-nine" data-toggle="tab">
            {{$t('cal_leftmenu_positionSize')}} </a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link" href="#about-ten" data-toggle="tab">
            Risk Percentage</a>
            </li> -->
            <li class="nav-item">
                <a class="nav-link" href="#about-eleven" data-toggle="tab">
            {{$t('cal_leftmenu_currencyConv')}} </a>
            </li>
        </ul> 
       

    </div>
</template>
<script>
    export default {
        name: 'leftmenu',
        data() {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/leftmenu.vue